export class ServiceFilter {
    name!: string;
}


